import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";

const Loading = () => (
  <Dimmer active page>
    <Loader />
  </Dimmer>
);
export default Loading;
